import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    ClientName: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    Email: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    Reference: {
      validations: []
    },
    Theme: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    EventExtra1: {
      validations: []
    },
    EventExtra2: {
      validations: []
    },
    EventExtra3: {
      validations: []
    },
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'FirstName',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'LastName',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'Email',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'XLarge',
            label: 'Company',
            mapping: 'ClientName',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone *',
            mapping: 'TelNumber',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Type of Event *',
            mapping: 'Theme',
            customClasses: ['no-label']
          },
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Preferred Event Date',
            mapping: 'EventDate',
            customClasses: ['no-label']
          },
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Secondary Event Date',
            mapping: 'EventExtra1',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'XLarge',
            label: 'What type(s) of Menu are you considering?',
            mapping: 'headerLabel',
            customClasses: ['heading']
          },
          {
            type: 'label',
            size: 'Medium',
            label: 'Is there anything we can help with?',
            mapping: 'headerLabel',
            customClasses: ['heading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'XLarge',
            options: [
              { label: 'Brunch', value: 'Brunch' },
              { label: 'Lunch', value: 'Lunch' },
              { label: 'Dinner', value: 'Dinner' },
              { label: 'Cocktail Menu', value: 'Cocktail Menu' },
              { label: 'Chef\'s Tasting Menu', value: 'Chef\'s Tasting Menu' }
            ],
            mapping: 'EventExtra2'
          },
          {
            type: 'checkbox-list',
            size: 'Medium',
            options: [
              { label: 'Flowers', value: 'Flowers' },
              { label: 'Decor', value: 'Decor' },
              { label: 'Cake', value: 'Cake' },
              { label: 'Balloons', value: 'Balloons' },
              { label: 'Entertainment', value: 'Entertainment' }
            ],
            mapping: 'EventExtra3',
            customClasses: ['checkbox']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Number of Guests * ',
            mapping: 'plannedguestcount',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'How Did you Hear About Us?',
            mapping: 'Reference',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Special requests? Questions? Please ask away!',
            mapping: 'Notes',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit for Availabilty & Price Quote'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Red Raven Restaurant Contact Form',
    formId: '411',
    clientKey: '66EDD825-D6D3-4BB8-8DA2-BEC1FEEF956A',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/Dev/web_inquiry/inquiry-renderer/client_forms/redraven/form_structure.js